import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NewTransaction from "@/pages/NewTransaction";
import TransactionsList from "@/pages/TransactionsList";
import Customers from "@/pages/Customers";
import Rates from "@/pages/Rates";
import Users from "@/pages/Users";
import Reports from "@/pages/Reports";
import AppLayout from "@/components/AppLayout";
import "@/App.css";

function Guard({ children, roles }) {
  const { user, loading } = useApp();
  if (loading) return <div className="flex h-screen items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Guard><AppLayout /></Guard>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/new" element={<NewTransaction />} />
        <Route path="/transactions" element={<TransactionsList />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/rates" element={<Rates />} />
        <Route path="/users" element={<Guard roles={["admin"]}><Users /></Guard>} />
        <Route path="/reports" element={<Reports />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" theme="dark" richColors />
      </BrowserRouter>
    </AppProvider>
  );
}
